import React, { useState } from 'react';
import './index.scss';
import GameStore from '@/pages/opinion/pages/Performance/components/GameStore';

export default function StoreRankingCard(props: any) {
  const {userId, gameInfo, filter} = props
  const userInfo = {
    userid: userId
  }
  const newGameInfo = {
    edition_unified_id: gameInfo.gameId || '',
    entity_type: gameInfo.entityType || '',
    id_type: gameInfo?.id_type || "edition_id"
  }
  // console.log("gameInfo_INT", gameInfo)
  return (
    <GameStore filter={filter} userInfo={userInfo} gameInfo={newGameInfo}/>
  );
}
